import React, { FC, useEffect, useCallback } from 'react';
import { GridThemeProvider } from 'styled-bootstrap-grid';
import { WithStyle } from '../../utils/with-style';
import ModalContext from './modal-context';
import { BodyOverflowStyled, ModalBackgroundStyled, ModalWrapperStyled } from './modal.styled';
import { ModalStaticProps, ModalProps } from './types';
import ModalDialog from './modal-dialog';
import ModalHeader from './modal-header';
import ModalBody from './modal-body';
import ModalFooter from './modal-footer';
import { gridThemeDefault } from '../../const/grid';

export const Modal: FC<ModalProps> & WithStyle & ModalStaticProps = props => {
  const { isOpen, onClose, children, $size, afterOpenModal, backdrop } = props;

  const handleEscPress = useCallback((e: any) => e.keyCode === 27 && onClose?.(), []);

  useEffect(() => {
    document.addEventListener('keydown', handleEscPress);
    return () => {
      afterOpenModal && afterOpenModal();
      document.removeEventListener('keydown', handleEscPress);
    };
  }, []);

  return (
    isOpen && (
      <ModalWrapperStyled {...props}>
        <BodyOverflowStyled />
        {backdrop && <ModalBackgroundStyled onClick={onClose} />}
        <ModalContext.Provider value={props}>
          <GridThemeProvider {...gridThemeDefault}>
            <ModalDialog {...{ $size }}>{children}</ModalDialog>
          </GridThemeProvider>
        </ModalContext.Provider>
      </ModalWrapperStyled>
    )
  );
};

Modal.defaultProps = {
  isOpen: false,
  backdrop: true,
  $size: 'md',
};

ModalDialog.displayName = 'Modal.Dialog';
ModalHeader.displayName = 'Modal.Header';
ModalBody.displayName = 'Modal.Body';
ModalFooter.displayName = 'Modal.Footer';

Modal.Dialog = ModalDialog;
Modal.Header = ModalHeader;
Modal.Body = ModalBody;
Modal.Footer = ModalFooter;
